module.exports = __webpack_public_path__ + "static/media/sigil-thumb-4-targaryen.2800cf72.png";